import ThumbnailTextList from './ThumbnailTextList';
import { ThumbnailTextListProps, ThumbnailTextListValueProps } from './types';

export type { ThumbnailTextListProps, ThumbnailTextListValueProps };
export default ThumbnailTextList;
